import { useModuleBEM } from "@b2bportal/core-themes";
import { Page } from "@tenant/ui";
import clsx from "clsx";
import { WarningOutline } from "../AuthModule/WarningOutline";
import styles from "./ErrorPage.module.scss";

export const ErrorPage = ({
  children,
  title,
  className,
  showErrorIcon = true,
}: {
  children: React.ReactNode;
  title: string;
  className?: string;
  showErrorIcon?: boolean;
}) => {
  const [block, cn] = useModuleBEM(styles, "ErrorPage");

  return (
    <Page className={clsx(block, className)}>
      <div className={cn("container")}>
        <div className={cn("content")}>
          {showErrorIcon && <WarningOutline />}
          <h1 className={cn("title")}>{title}</h1>
          {children}
        </div>
      </div>
    </Page>
  );
};
